var BaseElementView = require( 'kitbuilder-views/base-element' ),
	ElementEmptyView = require( 'kitbuilder-views/element-empty' ),
	ColumnView;

ColumnView = BaseElementView.extend( {
	template: Marionette.TemplateCache.get( '#tmpl-kitbuilder-element-column-content' ),

	emptyView: ElementEmptyView,

	childViewContainer: '> .kitbuilder-column-wrap > .kitbuilder-widget-wrap',

	behaviors: {
		Sortable: {
			behaviorClass: require( 'kitbuilder-behaviors/sortable' ),
			elChildType: 'widget'
		},
		Resizable: {
			behaviorClass: require( 'kitbuilder-behaviors/resizable' )
		},
		HandleDuplicate: {
			behaviorClass: require( 'kitbuilder-behaviors/handle-duplicate' )
		},
		HandleAddMode: {
			behaviorClass: require( 'kitbuilder-behaviors/duplicate' )
		}
	},

	className: function() {
		var classes = BaseElementView.prototype.className.apply( this, arguments ),
			type = this.isInner() ? 'inner' : 'top';

		return classes + ' kitbuilder-column kitbuilder-' + type + '-column';
	},

	ui: function() {
		var ui = BaseElementView.prototype.ui.apply( this, arguments );

		ui.duplicateButton = '> .kitbuilder-element-overlay .kitbuilder-editor-column-settings-list .kitbuilder-editor-element-duplicate';
		ui.removeButton = '> .kitbuilder-element-overlay .kitbuilder-editor-column-settings-list .kitbuilder-editor-element-remove';
		ui.saveButton = '> .kitbuilder-element-overlay .kitbuilder-editor-column-settings-list .kitbuilder-editor-element-save';
		ui.triggerButton = '> .kitbuilder-element-overlay .kitbuilder-editor-column-settings-list .kitbuilder-editor-element-edit-trigger';
		ui.addButton = '> .kitbuilder-element-overlay .kitbuilder-editor-column-settings-list .kitbuilder-editor-element-add';
		ui.columnTitle = '.column-title';
		ui.columnInner = '> .kitbuilder-column-wrap';
		ui.listTriggers = '> .kitbuilder-element-overlay .kitbuilder-editor-element-trigger';

		return ui;
	},

	triggers: {
		'click @ui.addButton': 'click:new'
	},

	events: function() {
		var events = BaseElementView.prototype.events.apply( this, arguments );

		events[ 'click @ui.listTriggers' ] = 'onClickTrigger';
		events[ 'click @ui.triggerButton' ] = 'onClickEdit';

		return events;
	},

	initialize: function() {
		BaseElementView.prototype.initialize.apply( this, arguments );

		this.listenTo( kitbuilder.channels.data, 'widget:drag:start', this.onWidgetDragStart );
		this.listenTo( kitbuilder.channels.data, 'widget:drag:end', this.onWidgetDragEnd );
	},

	isDroppingAllowed: function() {
		var elementView = kitbuilder.channels.panelElements.request( 'element:selected' ),
			elType = elementView.model.get( 'elType' );

		if ( 'section' === elType ) {
			return ! this.isInner();
		}

		return 'widget' === elType;
	},

	changeSizeUI: function() {
		var columnSize = this.model.getSetting( '_column_size' ),
			inlineSize = this.model.getSetting( '_inline_size' ),
			columnSizeTitle = parseFloat( inlineSize || columnSize ).toFixed( 1 ) + '%';

		this.$el.attr( 'data-col', columnSize );

		this.ui.columnTitle.html( columnSizeTitle );
	},

	getSortableOptions: function() {
		return {
			connectWith: '.kitbuilder-widget-wrap',
			items: '> .kitbuilder-element'
		};
	},

	// Events
	onCollectionChanged: function() {
		BaseElementView.prototype.onCollectionChanged.apply( this, arguments );

		this.changeChildContainerClasses();
	},

	changeChildContainerClasses: function() {
		var emptyClass = 'kitbuilder-element-empty',
			populatedClass = 'kitbuilder-element-populated';

		if ( this.collection.isEmpty() ) {
			this.ui.columnInner.removeClass( populatedClass ).addClass( emptyClass );
		} else {
			this.ui.columnInner.removeClass( emptyClass ).addClass( populatedClass );
		}
	},

	onRender: function() {
		var self = this;

		self.changeChildContainerClasses();
		self.changeSizeUI();

		self.$el.html5Droppable( {
			items: ' > .kitbuilder-column-wrap > .kitbuilder-widget-wrap > .kitbuilder-element, >.kitbuilder-column-wrap > .kitbuilder-widget-wrap > .kitbuilder-empty-view > .kitbuilder-first-add',
			axis: [ 'vertical' ],
			groups: [ 'kitbuilder-element' ],
			isDroppingAllowed: _.bind( self.isDroppingAllowed, self ),
			onDragEnter: function() {
				self.$el.addClass( 'kitbuilder-dragging-on-child' );
			},
			onDragging: function( side, event ) {
				event.stopPropagation();

				if ( this.dataset.side !== side ) {
					Backbone.$( this ).attr( 'data-side', side );
				}
			},
			onDragLeave: function() {
				self.$el.removeClass( 'kitbuilder-dragging-on-child' );

				Backbone.$( this ).removeAttr( 'data-side' );
			},
			onDropping: function( side, event ) {
				event.stopPropagation();

				var newIndex = Backbone.$( this ).index();

				if ( 'bottom' === side ) {
					newIndex++;
				}

				self.addElementFromPanel( { at: newIndex } );
			}
		} );
	},

	onClickTrigger: function( event ) {
		event.preventDefault();

		var $trigger = this.$( event.currentTarget ),
			isTriggerActive = $trigger.hasClass( 'kitbuilder-active' );

		this.ui.listTriggers.removeClass( 'kitbuilder-active' );

		if ( ! isTriggerActive ) {
			$trigger.addClass( 'kitbuilder-active' );
            kitbuilder.getPanelView().hideContentPanel();
		}
	},

	onWidgetDragStart: function() {
		this.$el.addClass( 'kitbuilder-dragging' );
	},

	onWidgetDragEnd: function() {
		this.$el.removeClass( 'kitbuilder-dragging' );
	}
} );

module.exports = ColumnView;
